export class NotificationsService {
    static checkConfig() {
        return true;
    }

    static setup() {
        //
    }
}